// extracted by mini-css-extract-plugin
export default {"previewHeadline":"HWyml_TkKgRE_fwdIT9Z"};